import { permissionsService, logsService } from '@/services'

const TYPES = {
  ENABLE_PARTS: 'ENABLE_PARTS',
  FAVORITE_COMPANY: 'FAVORITE_COMPANY',
  BLOCK_SALE: 'BLOCK_SALE',
}

const state = () => ({
  enableParts: 0,
  favoriteCompany: null,
  blockSaleWithoutBalance: null,
})

const getters = {
  getEnableParts: (state) => {
    return state.enableParts
  },

  getFavoriteCompany: (state) => {
    return state.favoriteCompany
  },

  getBlockSale: (state) => {
    return state.blockSaleWithoutBalance
  },
}

const actions = {
  getPermissions ({ commit }, params) {
    return new Promise((resolve, reject) => {
      permissionsService.checkPermissions(params)
        .then(({ data: { permissions } }) => {
          commit(TYPES.ENABLE_PARTS, permissions)
          commit(TYPES.FAVORITE_COMPANY, permissions)
          commit(TYPES.BLOCK_SALE, permissions)

          // Commit no módulo products de priceAdd
          if (permissions && permissions.ACRESCIMO_PRECO_LIQUIDO !== undefined) {
            const priceAdd = Number(permissions.ACRESCIMO_PRECO_LIQUIDO)
            commit('products/SET_PRICEADD', priceAdd, { root: true })
          }

          resolve(permissions)
        }).catch(({ response }) => {
          logsService.logs({ alert: response })
          response !== undefined ? reject(response.data) : reject(response)
        })
    })
  },
}

const mutations = {
  [TYPES.ENABLE_PARTS] (state, payload) {
    state.enableParts = payload.CONJUNTO_HABILITADO
  },

  [TYPES.FAVORITE_COMPANY] (state, payload) {
    state.favoriteCompany = parseInt(payload.EMPRESA_PADRAO_TDRSCHERER)
  },

  [TYPES.BLOCK_SALE] (state, payload) {
    state.blockSaleWithoutBalance = parseInt(payload.BLOQUEAR_VENDA_SEM_SALDO)
    if (parseInt(payload.BLOQUEAR_VENDA_SEM_SALDO) === 1 && parseInt(payload.LIMITAR_ESTOQUE_FILIAIS) === 1) {
      state.blockSaleWithoutBalance = 2
    }
  },

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
